import { Breadcrumbs, Container, Grid, Link, useMediaQuery } from '@material-ui/core'
import React, { useEffect, useState } from 'react'
import { DropDownBtnHLPure, GridSelectionHLPure, ListViewPure, SearchBarHLPure, SimpleLoading } from '../../pures'
import { FilterIcon, businessIconDefault } from '../../../assets/logos/icons';
import { filterBy, orderBy } from "@progress/kendo-data-query";
import './digital-vault-categories.css';
import ViewType from '../digital-vault/viewType';
import moment from "moment";
import { changeFormatNumberToShow } from '../../../utils';

const initialSort = [
    {
        field: "name",
        dir: "asc",
    },
];

const initialFilter = {
    logic: "and",
    filters: [
        {
            field: "name",
            operator: "contains",
            value: "",
        },
    ],
};

const DigitalVaultCategoryCard = (props) => {
    const {
        dataItem: category,
        onClick,
        t
    } = props;

    const indicators = category.indicators;

    return (
        <button className='digitalVaultCompanyCard' onClick={() => onClick(category)}>
            <img className='digitalVaultCompanyCard-img' src={category.icon ? `${process.env.REACT_APP_AWS_S3_BUCKET_URL_ICONS}${category.icon}` : "https://a3cloud-qa.s3.us-west-2.amazonaws.com/microservices/MiFirma/assets/boveda-digital/DefaultCategory.svg"} alt={category.name} />
            <div className='digitalVaultCompanyCard-info'>
                <p className='digitalVaultCompanyCard-company'>{category.name}</p>
                <table className='digitalVaultCompanyCard-data'>
                    <tbody>
                        <tr>
                            <th>{t("digitalVaultCategoryCard.total.docs")}</th>
                            <td>{changeFormatNumberToShow(indicators.total, 5)}</td>
                        </tr>
                        <tr>
                            <th>{t("digitalVaultCategoryCard.total.exp")}</th>
                            <td>{changeFormatNumberToShow(indicators.folders, 5)}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </button>
    );
}

const CellColumnOne = (props) => {
    const {
        dataItem: category,
        onClick,
    } = props;

    return (
        <td onClick={() => onClick(category)} className='digitalVaultCategoriesView-col1'>
            <div className='digitalVaultCategoriesView-col1-content'>
                <img
                    alt="profile-img"
                    src={category.icon ? `${process.env.REACT_APP_AWS_S3_BUCKET_URL_ICONS}${category.icon}` : "https://a3cloud-qa.s3.us-west-2.amazonaws.com/microservices/MiFirma/assets/boveda-digital/DefaultCategory.svg"}
                    className="digitalVaultCategoriesView-col1-avatar"
                />
                <div>
                    <p className='digitalVaultCategoriesView-col1-name'>{category.name}</p>
                </div>
            </div>
        </td>
    )
}

const CellColumnText = (props) => {
    const {
        dataItem: category,
        onClick,
        column,
        localStorageService
    } = props;

    let content = null;

    switch (column) {
        case 2:
            let date = "no hay dato"
            if (category.updatedDate) {
                let preferredLanguage = localStorageService.getLocalStorageItem("preferredLanguage")
                let language = preferredLanguage || "es"
                moment.locale(language);
                date = moment(category.updatedDate).format("DD/MMM/YYYY")
                date = date.replaceAll(".", "")
                date = date.toLocaleLowerCase()
            }
            content = <p>{date}</p>
            break;
        case 3:
            content = <p>{category.updatedByUser || "no hay dato"}</p>
            break;
    }

    return (
        <td className={`digitalVaultCategoriesView-col${column}`} onClick={() => onClick(category)} >
            <div className={`digitalVaultCategoriesView-col${column}-content`}>{content}</div>
        </td>
    )
}

const CellColumnNumber = (props) => {
    const {
        dataItem: category,
        onClick,
        column,
    } = props;

    const indicators = category.indicators;
    let content = null

    switch (column) {
        case 4:
            content = changeFormatNumberToShow(indicators.total, 5)
            break;
        case 5:
            content = changeFormatNumberToShow(indicators.folders, 5)
            break;
    }

    return (
        <td className={`digitalVaultCategoriesView-colNumber`} onClick={() => onClick(category)} >
            <div className={`digitalVaultCategoriesView-colNumber-content`}>
                <p>{content}</p>
            </div>
        </td>
    )
}

const DigitalVaultCategoriesView = (props) => {
    const {
        isLoading,
        viewAsCards,
        setViewAsCards,
        breadcrumbItems,
        handleBreadcrumbClick,
        categories,
        setSelectedCategory,
        t,
        localStorageService,
        companies,
        selectedCompany
    } = props;

    const [categoriesGrid, setCategoriesGrid] = useState(categories);
    const [readOnly, setReadOnly] = useState(true)

    useEffect(() => {
        setCategoriesGrid(categories)
    }, [categories]);

    const [categorySearch, setCategorySearch] = useState("");
    const [filter, setFilter] = useState(initialFilter);

    useEffect(() => {
        setFilter({
            logic: "and",
            filters: [
                {
                    field: "name",
                    operator: "contains",
                    value: categorySearch,
                },
            ],
        });
    }, [categorySearch]);

    const [sort, setSort] = useState(initialSort);
    const pageable = categories.length < 28;

    const onCategorySelected = (category) => {
        if (!category.id) return;
        setSelectedCategory(category);
    }

    const CategoryCard = (props) => <DigitalVaultCategoryCard {...props} t={t} onClick={onCategorySelected} />

    const onChangeCompany = (id) => {
        const foundCompany = companies.find(company => company.company.id === id)
        props.setSelectedCompany(foundCompany)
        props.loadCategories()
    }

    const showShortHeader = useMediaQuery("(max-width:1300px)");
    const hideAssigned = useMediaQuery("(max-width:1100px)");
    const hideAssignedBy = useMediaQuery("(max-width:900px)");
    const hideDocuments = useMediaQuery("(max-width:620px)");

    const CategoryColumnOne = (props) => <CellColumnOne {...props} onClick={onCategorySelected} />
    const CategoryColumnTwo = (props) => <CellColumnText {...props} column={2} localStorageService={localStorageService} field={"updatedDate"} onClick={onCategorySelected} />
    const CategoryColumnThree = (props) => <CellColumnText {...props} column={3} field={"updatedByUser"} onClick={onCategorySelected} />
    const CategoryColumnFour = (props) => <CellColumnNumber {...props} column={4} field={"documents"} onClick={onCategorySelected} />
    const CategoryColumnFive = (props) => <CellColumnNumber {...props} column={5} field={"records"} onClick={onCategorySelected} />

    if (isLoading) return <SimpleLoading />

    const onlyCompanies = companies.map(company => company.company).sort((a, b) => {
        if (a.companyName < b.companyName) return -1
        if (a.companyName > b.companyName) return 1
        return 0
    })
    return (
        <Container disableGutters className='digitalVaultCategoriesView'>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <Grid container className={`digitalVaultView-filters ${viewAsCards ? "adjust" : null}`}>
                        {/* <span aria-hidden='true' className='hidden'></span> */}
                        <Grid item>
                            <DropDownBtnHLPure
                                onDropDownChange={(e) => onChangeCompany(e.target.value)}
                                optionsDropDown={onlyCompanies}
                                nameOption="companyName"
                                valueItem={"id"}
                                optionsValue={selectedCompany?.company?.id}
                            />
                        </Grid>
                        <Grid item>
                            <SearchBarHLPure
                                readOnly={readOnly}
                                onFocus={() => setReadOnly(false)}
                                onBlur={() => setReadOnly(true)}
                                placeholder={t("digitalVaultCategoriesView.search.categories")}
                                searchValue={categorySearch}
                                onSearchChange={(e) => setCategorySearch(e.target.value)}
                                icon={FilterIcon}
                            />
                        </Grid>
                        <ViewType viewAsCards={viewAsCards} setViewAsCards={setViewAsCards} />
                    </Grid>
                </Grid>
                <Grid item xs={12}>
                    <div className={viewAsCards ? "breadcrumbs-adjust" : null}>
                        <Breadcrumbs aria-label="Categorías">
                            {
                                breadcrumbItems.map(i => <Link
                                    href="#"
                                    onClick={(e) => handleBreadcrumbClick(e, i)}
                                    aria-current="page"
                                >
                                    {i.title}
                                </Link>)
                            }
                        </Breadcrumbs>
                    </div>
                </Grid>
                <Grid item xs={12} className={`digitalVaultView-data ${pageable ? null : "scroll"}`}>
                    {
                        viewAsCards
                            ? <ListViewPure
                                data={filterBy(orderBy(categoriesGrid, sort), filter)}
                                pageable={pageable}
                                take={6}
                                itemRendered={CategoryCard}
                                listClassName='digitalVaultView-cardView'
                                pagerClassName='digitalVaultView-cardView-pager'
                            />
                            : <GridSelectionHLPure
                                skip={0}
                                take={6}
                                pageable={pageable}
                                dataGrid={filterBy(orderBy(categoriesGrid, sort), filter)}
                                sortable={true}
                                sort={sort}
                                onSortChange={(e) => {
                                    setSort(e.sort);
                                }}
                                onRowClick={onCategorySelected}

                                titleRow1={t("digitalVaultCategoryCard.grid.title.1")}
                                cellColumnOne={CategoryColumnOne}
                                isCheckedColOne={"name"}
                                headerColumnOneClass={"digitalVaultCategoriesView-col1"}

                                statusColumn={!hideAssigned}
                                titleStatusColumn={t("digitalVaultCategoryCard.grid.title.2")}
                                cellColumnStatus={CategoryColumnTwo}
                                headerColumnStatusClass={"digitalVaultCategoriesView-col2"}

                                columnTwo={!hideAssignedBy}
                                titleRow2={t("digitalVaultCategoryCard.grid.title.3")}
                                cellColumnTwo={CategoryColumnThree}
                                headerColumnTwoClass={"digitalVaultCategoriesView-col3"}

                                columnThree={!hideDocuments}
                                titleRow3={showShortHeader ? t("digitalVaultCategoryCard.grid.title.short.4") : t("digitalVaultCategoryCard.grid.title.4")}
                                cellColumnThree={CategoryColumnFour}
                                headerColumnThreeClass={"digitalVaultCategoriesView-colNumber"}

                                columnFour
                                titleRow4={showShortHeader ? t("digitalVaultCategoryCard.grid.title.short.5") : t("digitalVaultCategoryCard.grid.title.5")}
                                cellColumnFour={CategoryColumnFive}
                                headerColumnFourClass={"digitalVaultCategoriesView-colNumber"}
                            />
                    }
                </Grid>
            </Grid>
        </Container>
    )
}

export default DigitalVaultCategoriesView